// #region imports

// --- Angular
import { Injectable } from "@angular/core";

// --- 3rd Party
import { TranslateService } from "@ngx-translate/core";

// --- HS Code
import { AppService } from "../app.service";
import { QuadrantsBaseService } from "./quadrants-base.service";

// #endregion

@Injectable({
  providedIn: 'root'
})
export class QuadrantsMockService extends QuadrantsBaseService {
  constructor(
    appService: AppService,
    translateService: TranslateService
  ) {
    super(appService, translateService);
  }

  load(): void {
    throw new Error("Method not implemented.");
  }
}
